var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.197 279.096C105.85 279.901 98.6549 279.743 84.7333 280.263C62.2794 281.103 41.4282 282.25 21.0894 283.706C17.281 283.978 8.49411 286.529 23.233 289.263C26.0932 289.794 31.7371 290.034 46.8872 290.346C66.9508 290.76 79.644 290.528 96.0224 290.685C111.173 290.829 115.677 292.325 145.158 292.716C150.939 292.792 172.052 292.803 180.371 292.559C210.671 291.674 206.733 289.264 218.451 288.627C224.236 288.313 229.251 288.066 236.212 287.526C242.187 287.063 244.238 286.336 246.702 286.023C250.799 285.502 266.358 286.206 275.366 284.747C278.207 284.287 272.785 283.765 264.233 283.263C253.587 282.638 225.525 280.395 221.233 279.764C204.022 277.232 179.578 278.067 138.197 279.096Z",
    fill: "url(#paint0_linear_10583_20078)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.148 172.184H80.0567C71.0594 172.184 63.1696 178.192 60.7769 186.865L49.7519 226.831C47.9952 233.199 52.786 239.49 59.3918 239.49H92.3007L109.148 172.184Z",
    fill: "#333E4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9717 195.37L87.5889 213.858H90.173V225.825L84.2387 284.044H75.3373L69.1694 231.533H55.9171L53.9755 284.043H45.0741L34.1157 226.691V213.984H34.2379V197.602C34.2379 194.809 34.8229 192.047 35.9553 189.494L47.8831 162.599C51.0283 155.507 58.0573 150.936 65.8151 150.936C73.6729 150.936 80.7725 155.625 83.857 162.852L96.0167 191.343C96.567 192.632 96.5507 194.093 95.9717 195.37Z",
    fill: "url(#paint1_linear_10583_20078)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.42 135.105C79.42 142.351 73.5328 148.224 66.2706 148.224C59.0083 148.224 53.1211 142.351 53.1211 135.105C53.1211 127.86 59.0083 121.986 66.2706 121.986C73.5328 121.986 79.42 127.86 79.42 135.105Z",
    fill: "#242D3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.691 201.082L90.8555 199.559V207.264L76.2926 208.685L67.9868 207.745L75.184 202.112C75.9089 201.544 76.7765 201.188 77.691 201.082Z",
    fill: "#242D3C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.2578,
    y: 207.314,
    width: 196.67,
    height: 6.84471,
    fill: "#333E4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.241 187.045L142.72 185.469L145.688 193.363L130.852 197.31H125.412L129.682 189.563C130.421 188.224 131.732 187.296 133.241 187.045Z",
    fill: "#242D3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.514 220.005L171.179 186.025C171.611 185.023 171.704 183.908 171.443 182.849L165.466 158.544C164.367 154.074 160.359 150.932 155.756 150.932H140.352L123.915 175.838L117.12 171.48L104.014 167.848L109.996 199.42C110.89 204.141 115.016 207.558 119.821 207.558H124.158L122.439 213.855H114.119H91.8789L91.2364 284.145H100.138L113.087 235.3L121.249 233.636L123.784 284.145H132.685L145.065 229.644C149.282 228.119 152.3 224.352 152.969 220.005H156.514Z",
    fill: "url(#paint2_linear_10583_20078)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.272,
    cy: 135.144,
    rx: 12.8577,
    ry: 12.8279,
    fill: "#242D3C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.329,
    cy: 124.506,
    rx: 10.436,
    ry: 10.4118,
    fill: "#242D3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.141 170.668H159.91C151.612 170.668 144.175 175.792 141.221 183.547L125.417 225.02C124.155 228.333 121.233 230.73 117.738 231.32L106.663 233.191C103.466 233.73 101.126 236.499 101.126 239.741H168.876L190.141 170.668Z",
    fill: "#333E4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8521 161.561L94.7005 168.942L105.133 173.531L117.001 171.557L103.199 156.444L102.404 157.211L105.278 163.032L91.8521 161.561Z",
    fill: "#242D3C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.584 219.422L242.508 163.281C240.101 155.366 231.957 150.687 223.907 152.592L188.817 192.376C187.344 194.045 186.532 196.194 186.532 198.42C186.532 203.466 190.623 207.557 195.669 207.557H217.597V214.084H206.318H186.537H184.008V226.419L208.901 284.144H208.975H217.803H217.876L210.423 232.339H218.13H238.611C245.214 232.339 250.756 228.093 252.785 222.266L259.584 219.422Z",
    fill: "url(#paint3_linear_10583_20078)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M206.188 190.123H200.364L197.007 186.259C195.328 184.327 195.38 181.438 197.128 179.567L202.749 173.549C203.459 172.789 204.632 172.699 205.448 173.343L208.615 175.837L206.188 190.123Z",
    fill: "#242D3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.721 138.058C229.721 145.143 223.965 150.886 216.864 150.886C209.762 150.886 204.006 145.143 204.006 138.058C204.006 130.974 209.762 125.23 216.864 125.23C223.965 125.23 229.721 130.974 229.721 138.058Z",
    fill: "#242D3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M284.096 169.9H276.158C274.08 169.9 272.218 171.186 271.482 173.129L252.264 223.867C250.845 227.614 247.327 230.151 243.324 230.317L213.981 231.527C209.712 231.704 206.342 235.216 206.342 239.488L257.38 239.488L284.096 169.9Z",
    fill: "#333E4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8745 182.529L73.4377 188.843L64.5128 192.769L54.3595 191.081L66.1676 178.151L66.8476 178.808L64.3885 183.788L75.8745 182.529Z",
    fill: "#242D3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.368 84.5545L142.656 23.4707C145.812 17.679 154.127 17.6758 157.287 23.4651L190.636 84.5489C193.668 90.1021 189.649 96.8755 183.322 96.8755H116.685C110.361 96.8755 106.341 90.1076 109.368 84.5545Z",
    fill: "#F7B737"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.134 43.5996C153.134 41.8737 151.734 40.4746 150.009 40.4746C148.283 40.4746 146.884 41.8737 146.884 43.5996V67.2777C146.884 69.0036 148.283 70.4027 150.009 70.4027C151.734 70.4027 153.134 69.0036 153.134 67.2777V43.5996Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.791 81.9582C144.791 79.0817 147.123 76.7498 149.999 76.7498C152.876 76.7498 155.208 79.0817 155.208 81.9582C155.208 84.8347 152.876 87.1665 149.999 87.1665C147.123 87.1665 144.791 84.8347 144.791 81.9582Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10583_20078",
    x1: 145.564,
    y1: 278.094,
    x2: 145.564,
    y2: 292.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2A9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC756",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10583_20078",
    x1: 65.2668,
    y1: 150.936,
    x2: 65.2668,
    y2: 284.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10583_20078",
    x1: 131.412,
    y1: 150.932,
    x2: 131.412,
    y2: 284.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10583_20078",
    x1: 221.796,
    y1: 152.168,
    x2: 221.796,
    y2: 284.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC756"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductNotFound);
export default __webpack_public_path__ + "static/media/product_not_found.8418a8c933e84a1d869b7b753b03bbce.svg";
export { ForwardRef as ReactComponent };